import React, { useEffect, useState, useMemo } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Assignment from "@material-ui/icons/Assignment";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";
import Button from "components/CustomButtons/Button.js";
import swal from "sweetalert2";
import { MantineReactTable } from "mantine-react-table";
import {
  Box,
  ActionIcon,
  Tooltip,

} from "@mantine/core";
import { IconDownload, IconEye } from "@tabler/icons-react";
import { ExportToCsv } from "export-to-csv";
import { IconTrash, IconEdit } from "@tabler/icons-react";

import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import axios from "../../utils/axiosInstance";
import {
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,

} from "@mui/material";
import Pagination from "rc-pagination";
import { debounce } from "@material-ui/core";
import { toast } from "react-toastify";
const useStyles = makeStyles(styles);

export default function userManagement() {
  const location = useLocation();
  const shouldRefetch = location.state?.shouldRefetch;
  const isActiveFromDashboard = location.state?.isActive || false;
  const classes = useStyles();
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState("");
  const [showUserList, setShowUserList] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [debouncedSearchText, setDebouncedSearchText] = useState("");
  const [loadingDownload, setLoadingDownload] = useState(false);
  console.log(debouncedSearchText, "debouncedSearchText")
  useEffect(() => {
    const isUserManagementPage = location.pathname === "/admin/userManagement";
    const isEditing = location.pathname.includes("editUser");
    const isViewing = location.pathname.includes("viewUser");
    const isviewAdmin = location.pathname.includes("viewAdmin");

    // Only show the user list if not editing/viewing/etc.
    if (isUserManagementPage && !isEditing && !isViewing && !isviewAdmin) {
      setShowUserList(true);
    } else {
      setShowUserList(false);
    }
  }, [location.pathname]);

  const columns = useMemo(() => [
    {
      header: "User Id",
      accessorKey: "_id",
      size: 10,
    },
    {
      header: "Full Name",
      accessorKey: "fullName",
      size: 10,
    },
    {
      header: "Email Address",
      accessorKey: "emailAddress",
      size: 10,
    },
    {
      header: "Phone Number",
      accessorKey: "mobileNumber",
      size: 10,
    },

    {
      header: "Created Date",
      accessorFn: (row) =>
        row.createdDate !== undefined
          ? new Date(row?.createdDate).toISOString().split("T")[0]
          : "",
      size: 10,
    },

  ]);



  useEffect(() => {
    if (shouldRefetch) {
      getData(pageNumber, limit, search, debouncedSearchText , isActiveFromDashboard);
      window.history.replaceState({}, document.title);
    } else {
      getData(pageNumber, limit, search, debouncedSearchText , isActiveFromDashboard);
    }
  }, [pageNumber, limit, search, shouldRefetch, debouncedSearchText ,isActiveFromDashboard]);

  const getData = async (pageNumber, limit, search, debouncedSearchText , isActiveParam) => {
    const token = localStorage.getItem("token");
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/enduserlist`,
        {
          params: {
            pageNumber,
            limit,
            search: debouncedSearchText,
             ...(isActiveParam ? { isActive: true } : {})

          },
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      );

      setTotalPages(response?.data?.pagination?.totalPages || 1);
      setTableData(response.data.data);
    } catch (err) {
      console.log(err);

    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (row) => {
    const token = localStorage.getItem("token");
    const confirmed = await swal.fire({
      title: "Confirm Deletion",
      text: "Are you sure you want to delete?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
      allowOutsideClick: false,
      allowEscapeKey: true,
    });

    if (confirmed.isConfirmed) {
      try {
        const response = await axios.delete(
          `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/removeusers?userId=${row.original.userId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Access-Control-Allow-Origin": "*",
            },
          }
        );
        console.log(response);

        await swal.fire({
          icon: "success",
          title: "Deleted!",
          text: "You have successfully deleted the user.",
        });

        getData();
      } catch (error) {
        console.error(error, "error");
        if (error?.response?.status === 403) {
          await swal.fire({
            icon: "error",
            title: "Error",
            text: "You do not have permission to delete this user.",
          });
        }

      }
    } else {
      await swal.fire({
        icon: "info",
        title: "Cancelled",
        text: "User deletion has been cancelled.",
      });
    }
  };
  const handleModalView = async (row) => {

    navigate(`viewUser?userId=${row.original._id}`);
  };


  const handleDownload = async () => {
    try {
      setLoadingDownload(true);
      const response = await axios.get(`${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/enduserlistListDownload`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Access-Control-Allow-Origin": "*",
        },
        responseType: 'blob',
      });


      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Player_List.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      if (error.response.status === 403) {
        toast.error("You do not have permission to download this file.");
        return;
      }
      console.error('Download error:', error);
    } finally {
      setLoadingDownload(false);
    }
  }

  const handleOpenEditModal = async (rows) => {

    navigate(`editUser?userId=${rows.original._id}`);
  };

  useEffect(() => {
    if (location.pathname === "/admin/userManagement") {
      setSelectedOption("");
    }
  }, [location.pathname]);

  const handleChange = (event) => {
    const value = event.target.value;
    setSelectedOption(value);
    setShowUserList(false);
    if (value === "addUser") {
      navigate("addUser");
    } else if (value === "addAdmin") {
      navigate("addAdmin");
    }
  };
  const debouncedSearch = useMemo(() => debounce((value) => {
    setDebouncedSearchText(value);
    if (value === "") {
      setPageNumber(1);
      setLimit(10);
    }
  }, 500), []);
  return (
    <>
      {showUserList && (
        <GridContainer>
          <GridItem xs={12}>
            <Card>
              <CardHeader color="rose" icon>
                <CardIcon color="rose">
                  <Assignment />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>User Management</h4>
                <FormControl sx={{ float: "right", minWidth: 150, "& .MuiOutlinedInput-notchedOutline > span":"padding-right: 10px;" }}>
                  <InputLabel id="add-user-dropdown-label" >
                    Add Players
                  </InputLabel>
                  <Select
                    labelId="add-user-dropdown-label"
                    value={selectedOption}
                    onChange={handleChange}
                    label="Add Players"
                  >
                    <MenuItem value="addUser">Add Player</MenuItem>
                    <MenuItem value="addAdmin">Add Manager</MenuItem>
                  </Select>
                </FormControl>
              </CardHeader>
              {!loading ? (<CardBody>
                <MantineReactTable
                  columns={columns}
                  displayColumnDefOptions={{
                    "mrt-row-actions": {
                      mantineTableHeadCellProps: {
                        align: "center",
                      },
                      size: 120,
                    },
                  }}
                  enableFullScreenToggle={false}
                  enableHiding={false}
                  enableDensityToggle={false}
                  enableFilters={false}
                  enableColumnFilterModes
                  enablePagination={false}
                  initialState={{ showColumnFilters: true }}
                  positionToolbarAlertBanner="bottom"
                  data={tableData}
                  enableEditing
                  positionActionsColumn="first"
                  renderTopToolbarCustomActions={({ table }) => (
                    <Box
                      sx={{
                        display: "flex",
                        gap: "16px",
                        flexWrap: "wrap",
                        padding: "16px",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      {loadingDownload ? (
                        <CircularProgress size={24} style={{ color: "black" }} />
                      ) : (
                        <Button
                          onClick={handleDownload}
                          style={{ marginLeft: "auto" }}

                        >
                          Export All Rows
                        </Button>
                      )}
                      <Button
                        disabled={
                          table.getPrePaginationRowModel().rows.length === 0
                        }

                        onClick={() => {
                          navigate(`viewAdmin`);
                        }}
                        leftIcon={<IconDownload />}
                        variant="filled"
                      >
                        Admin Users
                      </Button>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          border: "1px solid #ccc",
                          borderRadius: "8px",
                          padding: "6px 12px",
                          width: "300px",
                          backgroundColor: "#fff",
                        }}
                      >
                        <i className="material-icons" style={{ color: "#aaa", marginRight: "8px" }}>
                          search
                        </i>
                        <input
                          type="text"
                          value={searchText}
                          placeholder="Search by Name or ID or Email"
                          onChange={(e) => {
                            setSearchText(e.target.value);
                            debouncedSearch(e.target.value);
                          }}
                          style={{
                            border: "none",
                            outline: "none",
                            width: "100%",
                            fontSize: "14px",
                          }}
                        />

                      </Box>
                    </Box>
                  )}
                  renderRowActions={({ row }) => (
                    <Box sx={{ display: "flex", gap: "16px" }}>
                      <Tooltip withArrow position="center" label="View">
                        <ActionIcon
                          onClick={() => handleModalView(row)}
                        >
                          <IconEye />
                        </ActionIcon>
                      </Tooltip>
                      <Tooltip withArrow position="left" label="Edit">
                        <ActionIcon onClick={() => handleOpenEditModal(row)}>
                          <IconEdit />
                        </ActionIcon>
                      </Tooltip>
                      <Tooltip withArrow position="right" label="Delete">
                        <ActionIcon
                          color="red"
                          onClick={() => handleDelete(row)}
                        >
                          <IconTrash />
                        </ActionIcon>
                      </Tooltip>
                    </Box>
                  )}
                />
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: "20px",
                  }}
                >
                  <Pagination
                    current={pageNumber}
                    total={totalPages * limit}
                    pageSize={limit}
                    onChange={(page) => setPageNumber(page)}
                  />
                </Box>
              </CardBody>) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "200px",
                    width: "100%",
                  }}
                >
                  <CircularProgress size={60} />
                </div>
              )}

            </Card>
          </GridItem>
        </GridContainer>
      )}
      <Outlet />

    </>
  );
}
